import * as React from "react";
import "./scss/index.scss";

var ContentPage = function ContentPage() {
  return React.createElement("div", null, "Content Page");
};

export default ContentPage;